import * as React from 'react'

import TextField, { defaultTextFieldProps } from './BaseTextField'
import { ITextFieldProps } from './types'

interface IProps extends ITextFieldProps {
  onChange: (value: string) => void
}

const cleaveOptions = {
  blocks: [4],
  numericOnly: true,
}

function CvcTextField(props: IProps) {
  const { onChange, ...moreProps } = props

  return (
    <TextField
      {...moreProps}
      cleaveOptions={cleaveOptions}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}
    />
  )
}

CvcTextField.defaultProps = defaultTextFieldProps

export default React.memo(CvcTextField)
